module.exports = true;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.1@core-js/library/modules/_library.js
// module id = 53
// module chunks = 0